import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=066790fa&"
import script from "./signin.vue?vue&type=script&lang=js&"
export * from "./signin.vue?vue&type=script&lang=js&"
import style0 from "./signin.vue?vue&type=style&index=0&id=066790fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports